import { loyaltycardList } from './tableColumns'
import {
	Loyaltycard,
	Series
} from './'
import listLoyaltyCards from './gql/listLoyaltyCards'
import getLoyaltyCard from './gql/getLoyaltyCard'
import updateLoyaltyCard from './gql/updateLoyaltyCard'
import createLoyaltyCard from './gql/createLoyaltyCard'
import updateManyLoyaltyCards from './gql/updateManyLoyaltyCards'
import FilterComponent from './fragments/ListFilter'
import { CreditCard, Import, History } from 'media/icons'
import CardImport from './modals/CardImport/'
import DayPoints from './modals/DayPoints'

import HistoryModal from 'components/HistoryModal'
import { isRouteDisabled } from 'sections/utils'
import getDiscountGroupNames from 'config/localServer/query/getDiscountGroupNames'

export default (t, rights, i18n) => ({
	id: '13',
	label: t('loyalty_card_section.caption'),
	typename: 'LoyaltyCard',
	recordsCounter: true,
	link: isRouteDisabled(rights, '13') ? null : 'kundenkarte',
	linkDisabled: isRouteDisabled(rights, '13'),
	icon: CreditCard,
	wideSideList: true,
	multiEditConfig: [
		{
			fieldName: 'isActive',
			type: 'checkbox',
			label: t('common.fields.isActive')
		},
		{
			fieldName: 'balanceDiscount',
			type: 'checkbox',
			label: t('loyalty_card_section.fields.loaded_discount')
		},
		{
			fieldName: 'alwaysDiscount',
			type: 'checkbox',
			label: t('loyalty_card_section.fields.discount_net_product')
		},
		{
			fieldName: 'cashLoad',
			type: 'checkbox',
			label: t('loyalty_card_section.fields.load_cash')
		},
		{
			fieldName: 'balancePoints',
			type: 'checkbox',
			label: t('loyalty_card_section.fields.points_on_load')
		},
		{
			fieldName: 'isPointsActive',
			type: 'checkbox',
			label: t('common.fields.isActive')
		},
		{
			fieldName: 'limit',
			type: 'numberInput',
			label: 'loyalty_card_section.fields.card_limit'
		},
		{
			fieldName: 'dayLimit',
			type: 'numberInput',
			label: 'loyalty_card_section.fields.daily_limit'
		},
		{
			fieldName: 'discount.numberOfPercent',
			queryOptions: {
				query: getDiscountGroupNames,
				variables: { language: i18n.language === 'English' ? 1 : 2 },
				modifyOptions: vals => vals.map((item, i) => ({ value: i + 1, label: item })),
				additionalOptions: [{ value: 0, label: '<kein>' }]
			},
			type: 'selectNumberOfPercent',
			label: t('loyalty_card_section.fields.discount_number')
		},
		{
			fieldName: 'discount.freePercent',
			type: 'numberInputPercent',
			label: `${t('loyalty_card_section.fields.discount')}, %`
		},
		{
			fieldName: 'discount.masterPercent',
			type: 'numberInputPercent',
			label: `${t('loyalty_card_section.fields.discount_management')}, %`
		}
	],
	subsections: [{
		name: t('loyalty_card_section.sub_sections.loyalty_card'),
		link: '',
		component: Loyaltycard,
		updateMutation: updateLoyaltyCard,
		fields: [
			'name', 'isActive', 'accessCode', 'balance', 'points', 'isPointsActive', 'limit', 'dayLimit',
			'clientName', 'clientSurname', 'salutation', 'additive', 'isUser', 'userId',
			{ fieldName: 'lastUpdatedAt', noForm: true },
			{ fieldName: 'user', children: ['id', 'name', 'code'], __typename: 'User' },
			'street', 'postcode', 'city', 'validPhoneNumber', 'email', 'type', 'creditClientId',
			{ fieldName: 'creditClient', children: ['id', 'name'], __typename: 'CreditClient' },
			{ fieldName: 'discount', children: ['freePercent', 'masterPercent', 'numberOfPercent'], __typename: 'DiscountType' },
			'balanceDiscount', 'alwaysDiscount', 'cashLoad', 'balancePoints', 'barCode', 'rfid'
		]
	}, {
		name: t('loyalty_card_section.sub_sections.series'),
		link: 'serien',
		component: Series
	}],
	itemActions: [{
		label: t('loyalty_card_section.strings.import_loyalty_cards'),
		Icon: Import,
		iconStyles: `margin-bottom: 6px;`,
		modalComponent: CardImport
	}, {
		label: t('loyalty_card_section.strings.balancePerDay'),
		modalComponent: DayPoints
	}, {
		label: t('product_section.strings.update_group'),
		action: ({ multiEdit, data }) => multiEdit.setIsActive(!multiEdit.isActive, data.id)
	}, {
		label: t('common.strings.history'),
		Icon: History,
		modalComponent: HistoryModal
	}],
	columns: loyaltycardList,
	listQuery: listLoyaltyCards,
	itemQuery: getLoyaltyCard,
	FilterComponent,
	addNewRecord: true,
	createMutation: createLoyaltyCard,
	newRecordsDefaults: {
		isActive: true
	},
	multiEditMutation: updateManyLoyaltyCards
})
